import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_LEGALSTATUS,
  DELETE_LEGALSTATUS,
  UPDATE_LEGALSTATUS,
  ADD_NEW_LEGALSTATUS,
} from "./actionType";

import {
  getLegalStatusSuccess,
  getLegalStatusFail,
  deleteLegalStatusSuccess,
  deleteLegalStatusFail,
  updateLegalStatusSuccess,
  updateLegalStatusFail,
  addLegalStatusSuccess,
  addLegalStatusFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveLegalStatusApi,
  getLegalStatusApi,
  updateLegalStatusApi,
  deleteLegalStatusApi,
  addNewLegalStatusApi,
} from "../../helpers/backend_helper";

function* getLegalStatus({ payload: legalStatus }) {
  try {
    const response = yield call(getLegalStatusApi, legalStatus);
    yield put(getLegalStatusSuccess(GET_LEGALSTATUS, response.data));
  } catch (error) {
    yield put(getLegalStatusFail(GET_LEGALSTATUS, error));
  }
}

function* onUpdateLegalStatus({ payload: legalStatus }) {
  try {
    if (legalStatus.setApprove) {
      const response = yield call(approveLegalStatusApi, legalStatus);
      yield put(updateLegalStatusSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateLegalStatusApi, legalStatus);
      yield put(updateLegalStatusSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateLegalStatusFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalStatus({ payload: legalStatus }) {
  try {
    const response = yield call(deleteLegalStatusApi, legalStatus);
    yield put(deleteLegalStatusSuccess({ legalStatus, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalStatusFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalStatus({ payload: legalStatus }) {
  try {
    const response = yield call(addNewLegalStatusApi, legalStatus);
    yield put(addLegalStatusSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalStatusFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetLegalStatus() {
  yield takeEvery(GET_LEGALSTATUS, getLegalStatus);
}

export function* watchUpdateLegalStatus() {
  yield takeEvery(UPDATE_LEGALSTATUS, onUpdateLegalStatus);
}

export function* watchDeleteLegalStatus() {
  yield takeEvery(DELETE_LEGALSTATUS, onDeleteLegalStatus);
}

export function* watchAddNewLegalStatus() {
  yield takeEvery(ADD_NEW_LEGALSTATUS, onAddNewLegalStatus);
}

function* legalStatusSaga() {
  yield all([
    fork(watchGetLegalStatus),
    fork(watchDeleteLegalStatus),
    fork(watchUpdateLegalStatus),
    fork(watchAddNewLegalStatus),
  ]);
}

export default legalStatusSaga;
